import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {/* <Route path={`${APP_PREFIX_PATH}/availability`} component={lazy(() => import(`./availability`))} /> */}
        <Route path={`${APP_PREFIX_PATH}/bookings`} component={lazy(() => import(`./bookings`))} />
        <Route path={`${APP_PREFIX_PATH}/information`} component={lazy(() => import(`./information`))} />
        <Route path={`${APP_PREFIX_PATH}/equipments`} component={lazy(() => import(`./equipments`))} />
        <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./home`))} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
